import React from 'react';
import { useNavigate } from 'react-router-dom';
import './pages.css';

const EndPage = () => {
  const navigate = useNavigate();
  const handleStartClick = () => {
    navigate('/'); 
  };
  return (
<div
  className="end-screen-wrapper"

>
   <div className='centertext'> <label className='pagetittle'>The end!</label></div>
   <div className='body-text'><p >You found our little actor Lumi! Do you wish to help her be a part of even more amazing films? Join us, the virtual productions Fontys minor!</p></div>
 
        <img className='qr-code' src='/images/qr-code.jpg'/>
    

        <div className='centertext'>
        <button onClick={handleStartClick}>Go back</button>
      </div>

   </div>
  );
};

export default EndPage;